/* The mockup's `.tiles` and `.tile`: four cards, the key number at 32px, tabular numerals. */
.tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

@media (max-width: 1279.98px) {
  .tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-4);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.label {
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.value {
  margin-block-start: var(--space-1);
  font-size: var(--font-size-32);
  font-variant-numeric: tabular-nums;
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
